export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pola formularza nr"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brak wymaganego identyfikatora"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pomyślnie się zalogowałeś, kontynuuj operacje w bankomacie"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kontynuuj transakcje bankomatowe"])}
}